import React, { ButtonHTMLAttributes } from 'react';
import { CircularProgress } from '@mui/material';
import { CSSObject, styled } from '@mui/material/styles';
import { rescheduleTheme } from '../rescheduleTheme';

export const ghostButtonStyles: CSSObject = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  minHeight: 52,
  padding: '0 20px',
  border: `1px solid ${rescheduleTheme.border}`,
  borderRadius: rescheduleTheme.radii.control,
  background: '#FFFFFF',
  color: rescheduleTheme.text,
  fontFamily: 'inherit',
  fontSize: 16,
  fontWeight: 500,
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover:not(:disabled)': { borderColor: rescheduleTheme.brand },
  '&:focus-visible': { outline: `2px solid ${rescheduleTheme.brand}`, outlineOffset: 2 },
  '&:disabled': { color: rescheduleTheme.disabledText, cursor: 'not-allowed' },
};

const StyledGhostButton = styled('button')(ghostButtonStyles);

export const GhostLink = styled('a')(ghostButtonStyles);

type GhostButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { loading?: boolean };

export const GhostButton = ({ loading, disabled, children, type = 'button', ...buttonProps }: GhostButtonProps) => (
  <StyledGhostButton type={type} disabled={disabled || loading} aria-busy={loading || undefined} {...buttonProps}>
    {loading && <CircularProgress size={18} color="inherit" />}
    {children}
  </StyledGhostButton>
);
